/**
 * Permission strings used in api_token scopes.
 */
export const PERMISSIONS = [
  'workspace:read',
  'workspace:write',
  'workspace:admin',
  'project:read',
  'project:write',
  'project:admin',
  'task:read',
  'task:write',
  'task:delete',
  'comment:read',
  'comment:write',
  'sprint:read',
  'sprint:write',
  'label:read',
  'label:write',
  'member:read',
  'member:write',
  'page:read',
  'page:write',
  'page:delete',
] as const

export type Permission = (typeof PERMISSIONS)[number]

/** Map high-level verbs to permission strings. */
export function requiredPermissionFor(action: string): Permission {
  if (action.startsWith('page.delete')) return 'page:delete'
  if (action.startsWith('page.')) return 'page:write'
  if (action.startsWith('task.delete')) return 'task:delete'
  if (action.startsWith('task.')) return 'task:write'
  if (action.startsWith('comment.')) return 'comment:write'
  if (action.startsWith('sprint.')) return 'sprint:write'
  if (action.startsWith('label.')) return 'label:write'
  if (action.startsWith('member.')) return 'member:write'
  if (action.startsWith('project.')) return 'project:write'
  if (action.startsWith('workspace.')) return 'workspace:write'
  return 'task:read'
}